import React, { useRef, useState } from "react";
import { Form, Button, Card, Alert } from "react-bootstrap";
// 使用自定义 Hook 获取认证相关操作和当前用户信息
import { useAuth } from "../../contexts/AuthContext";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Form.css";

const ForgotPassword = () => {
  // 使用 useRef 存储输入框引用，用于获取用户输入的电子邮件
  const emailRef = useRef();

  // 从认证上下文中提取重置密码方法和当前用户信息
  const { resetPassword, currentUser } = useAuth();

  // 用于存储错误信息和成功提示，以及加载状态
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // 异步处理提交表单以重置密码
  const handleSubmit = async (e) => {
    e.preventDefault(); // 阻止表单默认提交行为

    // 清除之前的消息和错误，并开启加载状态
    setMessage("");
    setError("");
    setLoading(true);

    try {
      // 调用重置密码函数，传入输入框中的邮箱地址
      await resetPassword(emailRef.current.value);
      // 成功后设置成功提示信息
      setMessage("Check your inbox for further instructions");
    } catch (err) {
      // 控制台输出错误日志，并设置错误提示信息
      console.error("Reset password error:", err);
      setError("Failed to reset password");
    } finally {
      // 操作结束后关闭加载状态
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      {/* 使用 Card 组件构建表单界面 */}
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">Password Reset</h2>

          {/* 如果用户已登录，则显示用户的邮箱 */}
          {currentUser?.email && (
            <div className="text-center mb-3">{currentUser.email}</div>
          )}

          {/* 显示错误或成功提示 */}
          {error && <Alert variant="danger">{error}</Alert>}
          {message && <Alert variant="success">{message}</Alert>}

          {/* 表单区域，提交后调用 handleSubmit */}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                ref={emailRef}
                required
                placeholder="Enter your email"
              />
            </Form.Group>

            {/* 提交按钮，加载时禁用并显示“Processing...” */}
            <Button disabled={loading} className="w-100 mt-3" type="submit">
              {loading ? "Processing..." : "Reset Password"}
            </Button>
          </Form>

          {/* 链接到登录页面 */}
          <div className="w-100 text-center mt-3">
            <Link to="/login">Login</Link>
          </div>
        </Card.Body>
      </Card>

      {/* 链接到注册页面 */}
      <div className="w-100 text-center mt-2">
        Need an account? <Link to="/signup">Sign Up</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;